import { render, staticRenderFns } from "./TrendIcon.vue?vue&type=template&id=db390aa2"
import script from "./TrendIcon.vue?vue&type=script&lang=js"
export * from "./TrendIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports